export const TAX_BUCKET_TRANSACTIONS = {
  TAX_BUCKET_TRANSACTIONS_HEADER: 'TAX_BUCKET_TRANSACTIONS_HEADER',
} as const;
